import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { useDispatch, useSelector } from "react-redux";
import * as url from "../../api/uri_helper"
import Loader from "../loader";
import axios from 'axios';
import Table, { Icon, Button } from "antd/lib/table";
import { useHistory } from "react-router-dom";
import Layout from '../Layout';
import updateIcon from "../../assets/images/updateIcon.svg"
import "antd/dist/antd.css";
import '../../../src/custom.css'
import { Select } from 'antd';
import toast, { Toaster, useToasterStore } from 'react-hot-toast';
import { getQrDataDetails } from '../../Redux/Actions/QrDetails';
import { Tooltip } from 'antd';
import Edit_light from "../../assets/images/Edit_light.svg";
import Trash_light from "../../assets/images/Trash_light.svg";
import { Modal, Skeleton } from 'antd';
import { getQrCodeData } from '../../Redux/Actions/QR';
import { SetCompanyDetails } from '../../Redux/Actions/CompanyActions';
import { setMediaTypes } from '../../Redux/Actions/MediaActions';
import { getAllLocationByCompanyId } from '../../Redux/Actions/LocationByCompany';
import { getAllQRByLocationId } from '../../Redux/Actions/qrByLocationId';
import Union from "../../assets/images/Union.svg";
import AddImage from "../../assets/images/Add.svg";
import { Link } from 'react-router-dom';
import Switch from "react-switch";
import { fetchAllLocationByCompanyId, fetchAllQRByLocationId, fetchAllQrCodes, fetchSitesByCompanyId, fetchCompanyDetails, fetchMediaData, fetchAllParentChildQRId } from '../../Redux/Api/fetch.api';
import { getQrParentChildData } from '../../Redux/Actions/QRParentChild';
import { useTranslation } from "react-i18next";
const TOAST_LIMIT = 1;

const ParentChildQRMedia = () => {
    const { t } = useTranslation("dashboard");
    const allCompanyDetails = useSelector((state) => state.allCompanyDetails.company);
    const allMediaTypes = useSelector((state) => state.allMediaType.mediaTypes);
    const selectedCompanyLocations = useSelector((state) => state.allLocationByCompany.allLocationByCompanyId);
    const selectedQrByLocation = useSelector((state) => state.allQRByLocationId.allQRByLocation);
    const { toasts } = useToasterStore();
    const [showAllData, setShowAllData] = useState(false);
    const [pageSize, setPageSize] = useState(100);
    useEffect(() => {
        toasts
            .filter((t) => t.visible) // Only consider visible toasts
            .filter((_, i) => i >= TOAST_LIMIT) // Is toast index over limit
            .forEach((t) => toast.dismiss(t.id)); // Dismiss – Use toast.remove(t.id) removal without animation
    }, [toasts]);
    const [options, setOptions] = useState({
        pagination: { current: 1 }, pageSize: pageSize
    });

    const [loading, setLoading] = useState(false);
    const [pageData, setPageData] = useState({});
    const [table, setTable] = useState([]);
    const [tableChild, setTableChild] = useState();
    const [total, setTotal] = useState()
    const [qRcodeId, setQRCodeId] = useState("");
    const [mastererror, setMasterError] = useState(false);
    const [currentCompanyId, setCurrentCompanyId, getCurrentCompanyId] = useState(0);
    const [currentLocationId, setCurrentLocationId] = useState(0);
    const [currentQRId, setCurrentQRId] = useState(0);
    const [currentMediaId, setCurrentMediaId] = useState(0);
    const dispatch = useDispatch();
    const history = useHistory();
    const [showButton, setShowButton] = useState(false);
    const [iswithmasterqr, setisWithmasterQr] = useState(false);
    const [qRcodeadd, setQRCodeadd] = useState();
    const [mediaadd, setMediaadd] = useState();
    const [checkedListOfIds, setCheckedListOfIds] = useState([]);
    const [checkedListOfParent, setCheckedListOfParent] = useState([]);
    const [count, setCount] = useState(0);
    const [qRcodeError, setQRCodeError] = useState(false);
    const [siteData, setSiteData] = useState([]);
    const comingsiteId = localStorage.getItem('SiteId');
    const searchBtnRef = useRef();


    useEffect(() => {
        ReadSearchedItem()
        // searchQrDetails(options, true, showAllData);
        getCompanyDetails()
        getMediaData()
        setPageData(options)
        getQRDetails()


    }, [])

    useEffect(() => {
        if (currentCompanyId > 0)
            allQRByLocation()
    }, [currentLocationId])

    useEffect(() => {

        if (currentCompanyId > 0)
            getSitesByCompanyId();
        // getAllLocationByCompany();
    }, [currentCompanyId]);

    const getQRDetails = () => {
        fetchAllQrCodes()
            .then(response => {
                dispatch(getQrCodeData(response.data))
            }
            )
            .catch((err) => {
                console.log("Err: ", err);
            })
    }

    const getCompanyDetails = () => {
        fetchCompanyDetails()
            .then(response => dispatch(SetCompanyDetails(response.data)))
            .catch((err) => {
                console.log("Err: ", err);
            })
    }

    const getMediaData = () => {
        fetchMediaData()
            .then(response => dispatch(setMediaTypes(response.data)))
            .catch((err) => {
                console.log("Err: ", err);
            })
    }

    const getSitesByCompanyId = () => {
        fetchSitesByCompanyId(currentCompanyId)
            .then(response => {

                if (response.data.success) {
                    setSiteData(response.data.data)
                }
            })
            .catch((err) => {
                console.log("Err: ", err);
            })

    }

    const resetButtonSearch = async () => {
        setCurrentLocationId(0);
        setCurrentMediaId(0);
        setCurrentQRId(0);
        setCurrentCompanyId(0);
        qRCodeIdToSend = 0;
        searchQrDetails(options, true, showAllData)
    }

    const handleCompanyChange = (e) => {

        let companyData = allCompanyDetails.filter(x => x.companyId == e.target.value)
        setCurrentCompanyId(e.target.value)
        if (e.target.value == 0) {
            setCurrentLocationId(0);
            setCurrentQRId(0);
            setSiteData([])
        }
    }

    const allQRByLocation = () => {
        fetchAllQRByLocationId(currentLocationId)
            .then(response => dispatch(getAllQRByLocationId(response.data)))
            .catch((err) => {
                console.log("Err: ", err);
            })
    }

    let qRCodeIdToSend = 0;
    if (qRcodeId && qRcodeId !== '') {
        qRCodeIdToSend = parseInt(qRcodeId);
    }
    const searchQrDetails = async (options, isReset = false, showAllData = false) => {

        setLoading(true)
        if (options && isReset) {
            options.pagination = isReset ? 1 : pageData.pagination;
            options.pageSize = pageData.pageSize;
        }

        const response = await axios.post(url.GET_PARENTCHILDQRDETAIL, {
            //PageIndex: options.pagination.current ,
            PageIndex: isReset ? 1 : (options.pagination ? options.pagination.current : '1'),
            PageSize: isReset ? 100 : (options.pagination.pageSize !== undefined ? options.pagination.pageSize : options.pageSize),
            companyId: isReset ? 0 : currentCompanyId,
            locationId: isReset ? 0 : currentLocationId,
            mediaTypeId: isReset ? 0 : currentMediaId,
            QRcodeId: isReset
                ? 0
                : (currentQRId === 0
                    ? (qRCodeIdToSend !== undefined && qRCodeIdToSend !== null ? qRCodeIdToSend : 0)
                    : (currentQRId !== undefined && currentQRId !== null ? currentQRId : 0)),
            SiteId: !showAllData ? comingsiteId : 0
            //  SiteId: showAllData || currentCompanyId || qRCodeIdToSend > 0 ? 0 : comingsiteId
        }).then(response => {


            // Save Searched Items 
            dispatch(getQrDataDetails(response.data)),
                setTable(response.data.data)
            setTableChild(response.data.data)
            setTotal(response.data.data.length > 0 ? response.data.data[0].totalCount : 0);

            setOptions({
                ...options,
                pagination: {
                    current: isReset ? 1 : (options.pagination ? options.pagination.current : 1),
                    pageSize: isReset ? 100 : (options.pagination.pageSize || pageSize),
                    total: response.data.data.length > 0 ? response.data.data[0].totalCount : 0,
                    pageSizeOptions: ['100', '200'],
                    showSizeChanger: true,
                }
            });

            setLoading(false)
        })
            .catch((err) => {
                console.log("Err: ", err);
            });
    };

    const SaveSeachedItems = (qRcodeId) => {
        // Save QRcodeId into the local storage 
        localStorage.setItem('qrcodeid', qRcodeId)

    }

    const ClearSearchItem = () => {
        // Clear the QRcodeId from the local storage 
        localStorage.removeItem('qrcodeid')
    }


    const ReadSearchedItem = () => {
        ClearSearchItem()
        // Get the QRcodeId from the local storage 
        const searchedQRId = window.localStorage.getItem('qrcodeid')
        if (searchedQRId) {
            setQRCodeId(searchedQRId);
            qRCodeIdToSend = searchedQRId;
            searchQrDetails(options, false, showAllData)
        }
        else {
            searchQrDetails(options, true, showAllData)
        }
    }

    const assignThumbnail = async (mediaId, qrCodeId) => {
        setLoading(true);
        var formData = new FormData();
        formData.append('QRCodeID', qrCodeId);
        formData.append('MediaId', mediaId);
        const response_ = await axios({
            method: 'post',
            url: url.POST_UpdateThumbnail,
            data: formData
        }).then(response => {
            searchQrDetails(options, true, showAllData)
            setLoading(false);
            toast.success(response.data.message, {
                className: "toastSuccess",
            });
        })
    }

    const handleCheck = (mediaId, qrcodeid) => {
       
        setisWithmasterQr(true);
        setQRCodeadd(qrcodeid);
        setMediaadd(mediaId)

        var updatedList = [...checkedListOfIds];
        if (event.target.checked) {
            updatedList = [...checkedListOfIds, mediaId];
        } else {
            updatedList.splice(checkedListOfIds.indexOf(mediaId), 1);
        }
        setCheckedListOfIds([...updatedList]);
    };

    const handleCheckBox = (qrcodeid) => {
        setisWithmasterQr(true);
        setQRCodeadd(qrcodeid);


        var updatedList = [...checkedListOfParent];
        if (event.target.checked) {
            updatedList = [...checkedListOfParent, qrcodeid];
        } else {
            updatedList.splice(checkedListOfParent.indexOf(qrcodeid), 1);
        }
        setCheckedListOfParent([...updatedList]);
    };
    const handleEdit = (qRcodeId, mediaId) => {
        uncheckcheckbox();
        setisWithmasterQr(false);
        history.push('/Update/QR/QrCodeId/' + qRcodeId + '/MediaId/' + mediaId)

    }

    const handleaddwithcheck = () => {

        if (checkedListOfIds.length > 1) {
            toast.error(t("CannotApplyMasterMultiple"), {
                className: "toastSuccess",
            });
            uncheckcheckbox();
            setCheckedListOfIds("");
        }
        else {
            if (checkedListOfParent.length <= 1) {
                history.push('/Add/QR/QrCodeId/' + qRcodeadd)
            }
            // let url = `/Add/QR/QrCodeId/${qRcodeadd}`;
            // if (mediaadd) {
            //     url += `/MediaId/${mediaadd}`;
            // }
            // history.push(url);
        }

    }

    const handleDeleteMultiple = () => {
        {
            (checkedListOfIds.length > 1) ?
                confirm({
                    title: t("ConfirmDeleteMultipleRecords"),
                    okText: t("Yes"),
                    okType: 'danger',
                    cancelText: t("No"),
                    onOk() {
                        deleteMultipleMediaData()
                    },
                    onCancel() {
                        uncheckcheckbox()
                        setShowButton(false)
                        setCheckedListOfIds('')
                    },
                })
                :
                confirm({
                    title: t("ConfirmDeleteRecord"),
                    okText: t("Yes"),
                    okType: 'danger',
                    cancelText: t("No"),
                    onOk() {
                        deleteMultipleMediaData()
                    },
                    onCancel() {
                        uncheckcheckbox()
                        setShowButton(false)
                        setCheckedListOfIds('')
                    },
                })
        };
    }

    const uncheckcheckbox = () => {
        var items = document.getElementsByName('checkname');
        for (var i = 0; i < items.length; i++) {
            if (items[i].type == 'checkbox')
                items[i].checked = false;
        }
        setMasterError(false)
    }

    const { confirm } = Modal;
    const handleDelete = (mediaId) => {

        confirm({
            title: t("ConfirmDeleteRecord"),
            okText: t("Yes"),
            okType: 'danger',
            cancelText: t("No"),
            onOk() {
                deleteMediaData(mediaId, options)
            },
            onCancel() {

            },
        });
    }

    const deleteMediaData = async (mediaId, options) => {
        setLoading(true)
        await axios.delete(url.DELETEMEDIA_QRDATA(mediaId), {
        }).then(response => {
            toast.success(response.data.message, {
                className: "toastSuccess",
            });
            searchQrDetails(options);
            setLoading(false)
            setShowAllData(false);
        }).catch((err) => {
            console.log("Err: ", err);
        });
        [total]
    }

    const deleteMultipleMediaData = async () => {

        setLoading(true)
        var formData = new FormData();
        formData.append('mediaIds', checkedListOfIds.toString());
        await axios.delete(url.DELETEMULTIPLEMEDIA_QRDATA, {
            data: formData
        }).then(response => {
            setLoading(false)
            searchQrDetails(options);
            setShowButton(false);
            toast.success(response.data.message, {
                className: "toastSuccess",
            });
            history.push('/AllMedia')
            setCheckedListOfIds("")
            setShowAllData(false);
        }).catch((err) => {
            console.log("Err: ", err);
            setLoading(false)
        });
    }


    const verifyQRCodeData = (id) => {
        fetchAllParentChildQRId(id)
            .then((response) => {

                if (response.data.success) {
                    dispatch(getQrParentChildData(response.data.data));
                }
            })

    }

    const columns = [
        {
            title: "",
            dataIndex: "checkbox",
            key: "checkbox",
            render: (text, record) => (
                <input
                    type="checkbox"
                    className="btn-checkbox"
                    name="checkname"
                    checked={checkedListOfParent.includes(record.qRcodeId)}
                    onChange={(e) => {
                        handleCheckBox(record.qRcodeId);
                        if (e.target.checked) {
                            // Allow only one selection at a time
                            setCheckedListOfParent([record.qRcodeId]);
                            setMasterError(false);
                        } else {
                            // Uncheck the selected checkbox
                            setCheckedListOfParent([]);
                            setMasterError(false);
                        }
                    }}
                />

            ),
        },

        {
            title: t("QRCode"),
            dataIndex: "qRcodeId",
            key: "i"
        },

        {
            title: t("ProductName"),
            dataIndex: "product_Name",
            className: "Products",
            render: (product_Name) => <Tooltip title={product_Name}>{product_Name}</Tooltip>,

        },

        {
            title: t("Company"),
            dataIndex: "companyName",
            className: "companyName",


        },

        {
            title: t("Site"),
            dataIndex: "name",
            className: "Locations",

        },

        {
            title: t("PrimaryQR"),
            dataIndex: "primaryQR",
            className: "Locations",

        },


        {
            title: t("UserSection"),
            dataIndex: "",
            render: (record) =>

            (
                <a href={record.qRcodeId} target="_blank" className="preview_Link" onClick={(e) => verifyQRCodeData(record.qRcodeId)}>{t("Preview")}

                </a>
            )
        },
    ]

    const handleSwitchChange = (checked) => {
        setQRCodeId()
        setCurrentCompanyId()
        setCurrentMediaId(0)
        setCheckedListOfParent([]);
        setShowAllData(checked);
        searchQrDetails(options, true, checked);
    };

    const expandedRowRender = (index) => {
        const nestedcolumns = [

            {
                title: " ",
                dataIndex: "",
                render: (data, mediaId) => (<div className="checkgroup">
                    {data.qrCode ?
                        <input type="checkbox" className="btn-checkbox" name="checkname"
                            onClick={() => { setShowButton(true); }} onChange={() => { handleCheck(data.mediaId, data.qrCode) }}
                            key={data.mediaId} {...checkedListOfIds.length < 1 ? setShowButton(false) : ""} {...checkedListOfIds.length <= 1 ? setMasterError(false) : ""}
                        ></input> : ""
                    }
                </div>)
            },
            {
                title: t("MediaId"),
                dataIndex: "mediaId",
                className: "QRMediaID",
                key: "tableid"
            },

            {
                title: t("GuideType"),
                dataIndex: "guideType",
                key: "Guidetype"
            },

            {
                title: t("AreaType"),
                dataIndex: "areaType",
                key: "areatype"
            },

            {
                title: t("MediaType"),
                dataIndex: "mediaType",
                key: "mediatype"
            },

            {
                title: t("Priority"),
                dataIndex: "priority",
                key: "mediatype"
            },

            {
                title: t("MediaDescription"),
                dataIndex: "",
                className: "mediaDescription ellipsss",
                render: (data) => (<Tooltip placement='topLeft' className="media-tooltip"

                    title={data.mediaKey == "Text" ?
                        <div>
                            <div dangerouslySetInnerHTML={{
                                __html: data.mediaDescription
                            }}>
                            </div>
                        </div> : data.mediaDescription
                    }>

                    {data.mediaKey == "Text" ? <span className="preview_Link_desc">{t("ViewText")}</span> : data.mediaDescription}

                </Tooltip>)
            },

            {
                title: t("AssignThumbnail"),
                dataIndex: "thumbnailID",
                render: (thumbnailID, mediaType) => (
                    <div className="thumbs">
                        {mediaType.qrCode ?
                            mediaType.mediaType === "Image" &&

                            < input type="radio" className="btn-radio" name={mediaType.qrCode + '_radio'}
                                checked={thumbnailID != null} onChange={() => { assignThumbnail(mediaType.mediaId, mediaType.qrCode) }}
                            ></input> : ""
                        }
                        {mediaType.qrCode && mediaType.mediaType === "Image" ? thumbnailID != null && <img className="thumb img add" src={`${mediaType.fileurl}`} /> : ""}
                    </div>)

            },

            {
                title: t("Action"),
                dataIndex: "",
                render: (data, qRcodeId, mediaId) => (
                    <>
                        {data.qrCode ? < button className="table-btn" >
                            <img src={Edit_light} onClick={() => handleEdit(data.qrCode, data.mediaId)}></img>
                        </button> : ""}
                        {data.qrCode ?
                            <button className="table-btn" >
                                <img src={Trash_light} onClick={() => handleDelete(data.mediaId)}></img>
                            </button> : ""}

                    </>
                )
            },
        ]
        return <Table className="nested-table" columns={nestedcolumns} dataSource={
            tableChild[index].mediaQRRelations
        } pagination={false} />
    };

    const handleChange = (pagination, sorter) => {
        const shouldResetPageIndex = pagination.pageSize !== options.pagination.pageSize;

        const updatedPagination = {
            ...pagination,
            current: shouldResetPageIndex ? 1 : pagination.current
        };

        const updatedOptions = {
            ...options,
            pagination: updatedPagination
        };

        setOptions(updatedOptions);
        setPageData(updatedOptions);

        searchQrDetails(updatedOptions, false, true);
    };

    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            searchBtnRef.current.click();
            searchQrDetails(options, false, showAllData)
        }
    }


    return (
        <Layout title={t("ParentChildQRReview")}>
            <Toaster />
            <div className="position-relative reviewPage">
                <div className="card-box-header d-inline-flex w-100 align-items-center m-0 gap-3">
                    <div className="filter-section multi-filter d-flex flex-wrap p-0">
                        <div className="col d-flex align-items-center p-0">
                            <label className="filter-col me-3 mb-0">{t("SearchMediaLabel")}</label>
                            <div className="dropdown">
                                <button className="filter-btn dropdown-toggle d-flex align-items-center" type="button" id="dropdownFilterMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                    <span>{t("Filter")}</span> <img className='ms-2' src={Union} />
                                </button>
                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                    <div className="row g-3">
                                        <div className='col-md-12'>
                                            <div className='row justify-content-center align-items-center'>
                                                <div className='col-md-12 d-flex align-items-center searchbtQR'>
                                                    <label class="form-label mb-0 d-inline-block"><b>{t("EnterQRCodeLabel")}</b></label>
                                                    <div className='d-flex flex-column position-relative'>
                                                        <input className="form-control" placeholder={t("EnterQRCode")} type="text" maxLength="9"
                                                            value={qRcodeId == undefined ? "" : qRcodeId}
                                                            inputMode="numeric"

                                                            disabled={(!currentCompanyId && !currentLocationId && !currentMediaId && !currentQRId)
                                                                || (currentCompanyId == 0 && showAllData) || (!currentMediaId && !showAllData)
                                                                || (qRcodeId && !currentMediaId && !showAllData)
                                                                ? "" : "disabled"}
                                                            onChange={(e) => {
                                                                // Allow only digits
                                                                const onlyDigits = e.target.value.replace(/\D/g, "");
                                                                setQRCodeId(onlyDigits);
                                                                setCount(onlyDigits.length);

                                                                // Validation
                                                                if (onlyDigits.startsWith("0") || onlyDigits.length > 9) {
                                                                    setQRCodeError(t("EnterValidQRCodeError"));
                                                                } else {
                                                                    setQRCodeError("");
                                                                }
                                                            }}
                                                            onKeyDown={(e) => handleKeyPress(e)}
                                                        >
                                                        </input>
                                                        {count > 8 ? <small className='text-danger d-block qRcodeError top-100' >{t("InvalidData")}</small> : ""}
                                                        <small className='text-danger d-block qRcodeError top-100' >{qRcodeError}</small>
                                                    </div>
                                                    <strong>{t("OR")}</strong>
                                                </div>

                                            </div>
                                        </div>

                                        {showAllData ?
                                            <div className='col-md-6'>
                                                <label class="form-label">{t("Company")}</label>
                                                <select class="form-select mb-0  filter-select" aria-label=".form-select-lg example"
                                                    value={currentCompanyId}
                                                    disabled={!qRcodeId ? "" : "disabled"}
                                                    onChange={(e) => handleCompanyChange(e)}>

                                                    <option value="0">{t("SelectCompany")}</option>
                                                    {allCompanyDetails && allCompanyDetails.map(company =>
                                                        <option key={company.companyId} value={company.companyId}>
                                                            {company.companyName} </option>)}
                                                </select>
                                            </div> : ""
                                        }

                                        {showAllData ?
                                            <div className='col-md-6'>
                                                <label class="form-label">{t("Site")}</label>

                                                <select class="form-select mb-0  filter-select" aria-label=".form-select-lg example"
                                                    value={currentLocationId}
                                                    disabled={!qRcodeId ? "" : "disabled"}
                                                    onChange={(e) => { setCurrentLocationId(e.target.value) }}>
                                                    <option value="0">{t("SelectSite")}</option>
                                                    {
                                                        siteData && siteData.map(data => {
                                                            return <option key={data.siteId} value={data.siteId}>
                                                                {data.siteName}
                                                            </option>
                                                        })
                                                    }
                                                </select>
                                            </div> : ""
                                        }


                                        <div className='col-md-6'>
                                            <label class="form-label">{t("Media")}</label>
                                            <select class="form-select mb-0  filter-select" aria-label=".form-select-lg example"
                                                value={currentMediaId}
                                                disabled={!qRcodeId ? "" : "disabled"}
                                                onChange={(e) => {
                                                    setCurrentMediaId(e.target.value)
                                                }}>
                                                <option value="0">{t("SelectMedia")}</option>
                                                {
                                                    allMediaTypes && allMediaTypes.map(media =>
                                                        <option key={media.mediaTypeId} value={media.mediaTypeId}>
                                                            {media.name} </option>
                                                    )
                                                }
                                            </select>
                                        </div>
                                        {showAllData ?
                                            <div className='col-md-6'>
                                                <label class="form-label">{t("QRCode")}</label>
                                                <select class="form-select mb-0  filter-select" aria-label=".form-select-lg example"
                                                    value={currentQRId}
                                                    disabled={!qRcodeId ? "" : "disabled"}
                                                    onChange={(e) => { setCurrentQRId(e.target.value) }}>
                                                    <option value="0">{t("SelectCode")}</option>
                                                    {
                                                        selectedQrByLocation && selectedQrByLocation.map(data => {
                                                            return <option key={data.qRcodeId} value={data.qRcodeId}>
                                                                {data.qRcodeId}
                                                            </option>
                                                        })
                                                    }
                                                </select>
                                            </div> : ""
                                        }

                                        <div className='col-md-12'>
                                            <button className="btn btn-primary pe-3 ps-3"
                                                ref={searchBtnRef}
                                                onClick={() => {
                                                    searchQrDetails(options, false, showAllData)
                                                    SaveSeachedItems(qRcodeId)

                                                }}
                                                disabled={
                                                    (!qRcodeId && !currentMediaId && !currentCompanyId)
                                                    //||
                                                    //(currentMediaId === 0 && !showAllData)
                                                }
                                            >{t("Search")}</button>
                                            <button className="btn btn-primary pe-3 ps-3 ms-2" onClick={
                                                () => {
                                                    setQRCodeId('');
                                                    resetButtonSearch();
                                                    setQRCodeError(false);
                                                    ClearSearchItem();
                                                }
                                            }>{t("Reset")}</button>
                                        </div>
                                    </div>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="col d-flex align-items-center p-0">
                        <label className="filter-col me-3 mb-0">{t("ShowAllLabel")}</label>
                        <Switch
                            onChange={handleSwitchChange}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            checked={showAllData}
                            onColor="#bb9977"
                            handleDiameter={20}
                            height={16}
                            width={35}
                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                            onHandleColor="#b97a57"
                        // activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                        />
                    </div>
                    <div className="ms-auto d-flex reviewbtn mobbtn">
                        {showButton ?
                            <button className="btn btn-primary d-flex align-items-center" onClick={() => handleDeleteMultiple()} {...checkedListOfIds.length >= 1}>
                                <img className="trash" src={Trash_light} ></img> {t("Delete")} </button>
                            : ""}
                        {/* {checkedListOfParent.length >= 1 && iswithmasterqr ? <Link className="btn btn-primary d-flex  ml-2"
                            to=
                            {{
                                // pathname: '/Add/QR/QrCodeId/' + qRcodeadd + '/MediaId/' + mediaadd,
                                state: {
                                    iswithmasterqr: iswithmasterqr,
                                },
                            }}
                            onClick={() => handleaddwithcheck()} ><img src={AddImage}></img>Add Media </Link>
                            : <Link className="btn btn-primary d-flex  ml-2" to="/Add/QR"  ><img src={AddImage}></img>Add Media </Link>} */}
                        {checkedListOfParent.length >= 1 && iswithmasterqr ? (
                            <Link
                                className={`btn btn-primary d-flex ml-2 ${checkedListOfIds.length >= 1 ? "disabled" : ""}`}
                                to={{
                                    state: {
                                        iswithmasterqr: iswithmasterqr,
                                    },
                                }}
                                onClick={(e) => {
                                    if (checkedListOfIds.length >= 1) {
                                        e.preventDefault(); // prevent navigation
                                        return;
                                    }
                                    handleaddwithcheck();
                                }}
                            >
                                <img src={AddImage} alt="Add" />
                                {t("AddMedia")}
                            </Link>
                        ) : (
                            <Link
                                className={`btn btn-primary d-flex ml-2 ${checkedListOfIds.length >= 1 ? "disabled" : ""}`}
                                to="/Add/QR"
                                onClick={(e) => {
                                    if (checkedListOfIds.length >= 1) {
                                        e.preventDefault(); // prevent navigation
                                    }
                                }}
                            >
                                <img src={AddImage} alt="Add" />
                                    {t("AddMedia")}
                            </Link>
                        )}


                    </div>


                </div>
            </div>
            <>
                <div className="table-responsive Viewer-table position-relative mb-4 device-type pagination-sticky data-table">
                    {loading ? <Loader /> : ''}
                    <Table
                        className='table-responsive antd--detail-table1 Viewer-table'
                        columns={columns}
                        dataSource={table}
                        expandedRowRender={(_, index) => expandedRowRender(index)}

                        pagination={
                            total > 100 ? options.pagination : false
                        }
                        onChange={handleChange}

                        scroll={{ x: "750px" }}
                    ></Table>
                </div>
            </>
        </Layout>
    )

}

export default connect()(ParentChildQRMedia);

